<template>
  <b-card>
    <b-card-title>
      <h4 class="text-center">
        Trip Status/Code
      </h4>
    </b-card-title>
    <div class="trip-details__trip-status">
      <h3 class="font-weight-bold">
        {{ tripCode }}
      </h3>
      <trip-status-badge :status="tripStatus" />
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BCardTitle,
} from 'bootstrap-vue'
import { inject, computed } from '@vue/composition-api'
import { tripColorGenerator, tripStatusFormatter } from '../../../hooks/tripStatusUtils'
import tripStatusBadge from '../../TripStatusBadge.vue'

export default {
  components: {
    BCard,
    BCardTitle,
    tripStatusBadge,
  },
  setup() {
    const trip = inject('trip')
    const tripStatus = computed(() => {
      if (trip.value) return trip.value.state
      return ''
    })
    const tripCode = computed(() => {
      if (trip.value) return trip.value.code
      return ''
    })
    return {
      tripStatus,
      tripCode,
      tripColorGenerator,
      tripStatusFormatter,
    }
  },
}
</script>

<style>
.trip-details__trip-status {
    height: 60%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

</style>
